import { render, staticRenderFns } from "./AzconCollectionCardSkeleton.vue?vue&type=template&id=e92374d6&scoped=true"
import script from "./AzconCollectionCardSkeleton.vue?vue&type=script&lang=js"
export * from "./AzconCollectionCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./AzconCollectionCardSkeleton.vue?vue&type=style&index=0&id=e92374d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e92374d6",
  null
  
)

export default component.exports